


























import { EnumTenancyTypeMD } from '@/api/com/MetaPattern/APP/MDA/User/EnumTenancyType';
import { User } from '@/api/com/MetaPattern/APP/MDA/User/User';
import { MDAConstant } from '@/libs/com/MetaPattern/MDA/Designer/Base/MDAConstant';
import { IDEContext } from '@/libs/com/MetaPattern/Product/IDE/IDEContext';
import { EnumStorageType, StorageLib } from '@/libs/com/MetaPattern/Product/IDE/Util/StorageLib';
import { Component, Vue, Watch } from 'vue-property-decorator';
@Component({
  components: {
  }
})
export default class UserSelect extends Vue {
  curUserId = '';

  mounted() {
    if (IDEContext.instance.curUser != null) {
      this.goNext();
    }
  }

  get users() {
    return IDEContext.instance.users;
  }

  getUserLabel(user: User) {
    return `${user.nickname}（${EnumTenancyTypeMD.getItemByValue(user.tenancy.tenancyType).displayName}）`;
  }

  selectChanged() {
    IDEContext.instance.curUser = IDEContext.instance.users.find(user => user.id === this.curUserId);
    this.goNext();
  }

  goNext() {
    StorageLib.instance.setItem(EnumStorageType.Expiration, MDAConstant.Account.USER_ID, IDEContext.instance.curUser.id, MDAConstant.Account.LOGIN_TIMEOUT);
    StorageLib.instance.setItem(EnumStorageType.Expiration, MDAConstant.Account.TENANCY_ID, IDEContext.instance.curUser.tenancy_ID, MDAConstant.Account.LOGIN_TIMEOUT);
    StorageLib.instance.setItem(EnumStorageType.Expiration, MDAConstant.Account.ACCOUNT_ID, IDEContext.instance.curAccountInfo.accountId, MDAConstant.Account.LOGIN_TIMEOUT);
    this.$store.dispatch('User/setUserAction', IDEContext.instance.curUser);
    this.$router.push('/loginInit');
  }
}
